import { JVersion } from './jversion';
import { CommonEnums } from '../../common.enums';

export class JDatabase {
    public name: string;
    public value: string;
    public default_Version: string;

    public dBVersions: Array<JVersion>;

    constructor() {
        this.name = CommonEnums.defaults.DEFAULT_EMPTY_STRING;
        this.value = CommonEnums.defaults.DEFAULT_EMPTY_STRING;
        this.default_Version = CommonEnums.defaults.DEFAULT_EMPTY_STRING;

        this.dBVersions = new Array<JVersion>();
    }
}